import React from 'react';
import {Link} from 'react-router-dom';

import {Content, ContentSection} from 'components';
import {Button, Heading} from 'components/ultra';
import Sidebar from 'containers/sidebar';
import {useReactRouter} from 'utilities/react-router';

enum ErrorReasons {
  InvalidToken = 'invalid_token',
  UnknownToken = 'unknown_token',
  InternalError = 'internal_error',
}

export function EmailConfirmation() {
  const {history, match} = useReactRouter<{
    state: 'error' | 'success';
    message?: ErrorReasons;
  }>();

  const {state} = match.params;
  const {message: errorReason} = match.params;
  if (state != 'error' && state != 'success') {
    history.push('/about');
  }

  const successMarkup = (
    <>
      <Heading element="h1" gradient={true}>
        Thank you
      </Heading>
      <Heading>for confirming your email address.</Heading>
      <p>
        Now that you've confirmed your email address, you're all set to use all
        Spurtli features. 🎉
        <br /> How about creating your first poster?
      </p>

      <Button severity="inverse" to="/poster/new">
        Create poster
      </Button>
    </>
  );

  const errorMarkup = (
    <>
      <Heading element="h1" gradient={true}>
        Sorry,
      </Heading>
      <Heading>we weren’t able to confirm your email address.</Heading>
      <p>
        {errorReason === ErrorReasons.InvalidToken && (
          <>Looks like the link you used is no longer valid.</>
        )}
        {errorReason === ErrorReasons.UnknownToken && (
          <>Looks like the link you used is not valid.</>
        )}
        {errorReason === ErrorReasons.InternalError && (
          <>Looks like something went wrong on our end.</>
        )}
        {errorReason == null && (
          <>Looks like something went wrong on our end.</>
        )}
        <br />
        Please <Link to="/contact">reach out to us</Link> so we can send you a
        new link.
      </p>
    </>
  );

  const content = state === 'success' ? successMarkup : errorMarkup;

  return (
    <>
      <Sidebar />
      <Content fullHeight verticalCenter>
        <ContentSection bottomSpacing>{content}</ContentSection>
      </Content>
    </>
  );
}
